import { gql } from '@eti/schema-types';

export const ORDER_QUERY = gql(/* GraphQL */ `
  query getOrder {
    orderNew {
      orderNumber
      customerDetails {
        name
      }
      trips {
        type
        bounds {
          segments {
            ... on TripSegment {
              __typename
              arrivedAt
              departuredAt
              destination {
                cityName
                code
              }
              duration
              marketingCarrier {
                code
                name
              }
              origin {
                cityName
                code
              }
              segmentId: id
            }
            ... on EventSegment {
              __typename
              duration
              segmentId: id
            }
          }
        }
      }
    }
  }
`);

export const travelerPricesFragment = gql(/* GraphQL */ `
  fragment RebookingTravelerPrices on RebookingTravelerPrice {
    id
    rebookingPrice {
      fareDifference {
        value
        currency {
          code
        }
      }
      taxDifference {
        value
        currency {
          code
        }
      }
      airlinePenalty {
        value
        currency {
          code
        }
      }
      airlineFees {
        value
        currency {
          code
        }
      }
      serviceFee {
        value
        currency {
          code
        }
      }
      totalDifference {
        value
        currency {
          code
        }
      }
    }
    travelerId
  }
`);

export const flightsFragment = gql(/* GraphQL */ `
  fragment RebookingFlights on RebookingTrip {
    id
    includedCabinBaggage {
      ...IncludedCabinBaggage
      includedPersonalItem
      size3d {
        height
        length
        width
      }
    }
    includedCheckedBaggage {
      ...IncludedCheckedBaggage
    }
    bounds {
      boundId: id
      segments {
        ... on TripSegment {
          __typename
          segmentId: id
          aircraftType
          arrivedAt
          includedCabinBaggage {
            ...IncludedCabinBaggage
          }
          includedCheckedBaggage {
            ...IncludedCheckedBaggage
          }
          cabinClassName
          departuredAt
          destination {
            code
            name
            cityCode
            cityName
          }
          duration
          equipmentCode
          flightNumber
          marketingCarrier {
            code
            name
          }
          numberOfTechnicalStops
          technicalStops {
            arrivalAt
            departureAt
            duration
            location {
              code
              name
              cityName
              cityCode
            }
          }
          operatingCarrier {
            code
            name
          }
          operatingInformation
          origin {
            code
            name
            cityCode
            cityName
          }
          segmentDetails {
            paxType
            numberOfSeatsLeft
          }
        }
        ... on EventSegment {
          __typename
          segmentId: id
          types
          duration
        }
      }
    }
    selectionKey
    type
    tripCharacteristics
    travelers {
      id
      ageType
    }
    paymentMethodPrices {
      ...PaymentMethodPrices
    }
    rebookingTravelerPrices {
      ...RebookingTravelerPrices
    }
    rebookingTravelerPricesWithoutPaymentDiscounts {
      ...RebookingTravelerPrices
    }
  }
`);

export const REBOOK_SEARCH_QUERY = gql(/* GraphQL */ `
  query RebookingSearch(
    $routes: [Route!]!
    $offset: Int
    $sortTypeCode: String
    $filters: [Filter!]
  ) {
    rebookingSearch(
      routes: $routes
      offset: $offset
      sortTypeCode: $sortTypeCode
      filters: $filters
    ) {
      availableFilters {
        code
        group
        label
        ... on RangeFilter {
          __typename
          code
          group
          label
          max
          min
          type
        }
        ... on SelectionFilter {
          __typename
          code
          group
          label
          isMultiChoice
          options {
            label
            value
          }
          type
        }
      }
      availableSortTypes {
        code
        name
      }
      flights {
        ...RebookingFlights
      }
      flightsCount
      filteredFlightsCount
      hasAirlineAncillaries
      rebookFlow
      resultSetMetaData {
        priceRange {
          min
          max
        }
        travelTimeRange {
          min
          max
        }
        marketingCarriers {
          code
          name
        }
      }
      routes {
        origin {
          code
          name
          cityCode
          cityName
          countryCode
          countryName
          continentCode
          continentName
        }
        destination {
          code
          name
          cityCode
          cityName
          countryCode
          countryName
          continentCode
          continentName
        }
        departureAt
        departureTimeOfDay
      }
      searchPath
      travelers {
        ageType
      }
    }
  }
`);

export const REBOOK_SEARCH_MORE_QUERY = gql(/* GraphQL */ `
  query RebookingSearchMore(
    $routes: [Route!]!
    $offset: Int
    $sortTypeCode: String
    $filters: [Filter!]
  ) {
    rebookingSearch(
      routes: $routes
      offset: $offset
      sortTypeCode: $sortTypeCode
      filters: $filters
    ) {
      flights {
        ...RebookingFlights
      }
    }
  }
`);
